import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.post.detail');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-portal-post-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.post.detail/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalPostDetailComponent implements OnInit, OnDestroy {
    public id: string = '';
    public tab: string = 'view';
    public data: any = null;
    public state: string = 'loading';
    public error: string = '';
    public saving: boolean = false;
    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.id = WizRoute.segment.id;
        this.tab = WizRoute.segment.tab || 'view';
    }

    public async ngOnInit() {
        await this.service.init();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const nextId = WizRoute.segment.id;
                const nextTab = WizRoute.segment.tab || 'view';
                if (nextId !== this.id) {
                    this.id = nextId;
                    this.tab = nextTab;
                    await this.load();
                } else if (nextTab !== this.tab) {
                    this.tab = nextTab;
                    await this.service.render();
                }
            }
        });
        if (!WizRoute.segment.tab) {
            this.service.href(`/posts/${this.id}/view`);
            return;
        }
        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public isNewPost() {
        return this.id === 'new';
    }

    public async load() {
        this.error = '';
        if (this.isNewPost()) {
            this.data = { title: '', content: '', category: '', status: 'draft', can_edit: true };
            this.tab = 'edit';
            this.state = 'ready';
            await this.service.render();
            return;
        }
        this.state = 'loading';
        this.data = null;
        await this.service.render();
        const { code, data } = await wiz.call('get', { id: this.id });
        if (code !== 200) {
            this.error = data?.message || data || '게시물을 불러오지 못했습니다.';
            this.state = 'error';
            await this.service.render();
            return;
        }
        this.data = data.post;
        this.state = 'ready';
        await this.service.render();
    }

    public async save() {
        if (this.saving) return;
        this.saving = true;
        await this.service.render();
        const action = this.isNewPost() ? 'create' : 'update';
        const params: any = { data: JSON.stringify(this.data) };
        if (!this.isNewPost()) params.id = this.id;
        const { code, data } = await wiz.call(action, params);
        this.saving = false;
        if ((action === 'create' && code === 201) || (action === 'update' && code === 200)) {
            if (action === 'create') {
                this.service.href(`/posts/${data.id}/view`);
                return;
            }
            await this.service.modal.success('저장되었습니다.');
            await this.load();
            return;
        }
        await this.service.modal.error(data?.message || data || '저장에 실패했습니다.');
        await this.service.render();
    }

    public async remove() {
        const confirmed = await this.service.modal.show({
            title: '게시물 삭제', message: '이 게시물을 삭제하시겠습니까?', action: '삭제', status: 'error'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call('delete', { id: this.id });
        if (code === 200) {
            this.service.href('/posts');
            return;
        }
        await this.service.modal.error(data?.message || data || '삭제에 실패했습니다.');
    }
}

export default PortalPostDetailComponent;